<template>
  <div class="big-container">
    <loading v-if="isLoading" />

    <v-snackbar v-model="showResult" :timeout="1500" :color="color" top>
      {{ result }}
    </v-snackbar>
    
    <v-card class="form-card" elevation="8">
      <v-card-title class="headline primary white--text">
        <v-icon large left class="mr-2">mdi-account-plus</v-icon>
        Cadastrar Novo Funcionário
      </v-card-title>

      <v-card-text class="pa-5">
        <v-form ref="form" v-model="formValid" lazy-validation>
          <v-row>
            <v-col v-if="false" cols="12" sm="12" md="6">
              <v-text-field v-model="editedItem.idFuncionario" label="cod"></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="editedItem.nome"
                label="Nome"
                :rules="obrigqtorioRules"
                prepend-icon="mdi-account"
                outlined
                clearable
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-text-field
                ref="biField"
                v-model="editedItem.idPEssoa"
                :rules="ruleBI"
                v-mask="mascara"
                :label="descricao"
                @input="verificarBI"
                @blur="verificarBI"
                prepend-icon="mdi-card-account-details"
                outlined
                clearable
                :hint="descricao === 'Bilhete' ? 'Formato: 123456789-LA-123' : ''"
                persistent-hint
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="6" class="d-flex align-center">
              <v-switch
                v-model="useOtherDoc"
                @change="outroDoc"
                :label="`Usar ${descricao === 'Bilhete' ? 'Outro Doc.' : 'Bilhete'}`"
                color="primary"
                class="mt-0"
              ></v-switch>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="editedItem.email"
                label="Email"
                :rules="ruleEmailRequired"
                prepend-icon="mdi-email"
                outlined
                clearable
              ></v-text-field>
            </v-col>
            
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="editedItem.telefone"
                :rules="obrigqtorioRules"
                label="Telefone"
                prepend-icon="mdi-phone"
                outlined
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          text
          @click="close"
          class="mr-3"
        >
          <v-icon left>mdi-close</v-icon>
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          depressed
          @click="save"
          :loading="isLoading"
        >
          <v-icon left>mdi-content-save</v-icon>
          Salvar
        </v-btn>
      </v-card-actions> 
    </v-card>
  </div>
</template>

<script>
import axios from '../../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
import loading from "../../../components/loading.vue";
import Swal from 'sweetalert2'

export default {
  directives: { mask },
  components: {
    loading
  },
  data: () => ({
    useOtherDoc: false,
    isLoading: false,
    funcionario_verificacao: [],
    usuarios: [],
    obrigqtorioRules: [
      value => !!value || 'Campo obrigatório.'
    ],
    
    mascara: '#########-AA-###',
    ruleEmailRequired: [
      value => value.length <= 50 || 'Máximo de 50 caracteres atingido',
      value => !!value || 'Campo obrigatório.',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'E-mail inválido.'
      }
    ],
    descricao: 'Bilhete',
    search: '',
    formValid: true,
    result: '',    
    editedItem: {
      idFuncionario: 0,
      idPEssoa: '', // bi
      i_id: '', // idinstituicao
      email: '',
      nome: '',
      telefone: ''
    },
    existingBi: false,
  }),
  computed: {
    ruleBI() {
      return [
        value => value.length === 16 || `Mínimo de 16 caracteres exigido (${value.length}/16).`,
        value => !this.existingBi || 'Número de documento já cadastrado!'
      ];
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    async initialize() {
      this.isLoading = true
      try {
        this.funcionario_verificacao = await axios.get('/BilheteFindAll')
        .then(res => res.data)
        .then(this.CarregaUsuarios())
      } catch (error) {
       Swal.fire('informação', 'Erro ao carregar a página!', 'error')
      } finally {
        this.isLoading = false;
      }
    },

    async verificarBI() {
      if (this.editedItem.idPEssoa) {
        try {
          let response = await axios.get(`/vericarBIFuncionario/${this.editedItem.idPEssoa}`)
          .then((res) => res.data)
  
          if(response.length) this.existingBi = true;
          else this.existingBi = false
          this.$refs.biField.validate();
        } catch (error) {
          Swal.fire('Informação', 'Erro ao verificar o número do documento!', 'error')
        }
      }
    },

    async CarregaUsuarios(search) {
      try {
        let payload = '';
        if (!search) {
          payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }
        this.usuarios = await axios.get('/usuarioFindAll/' + payload).then(res => res.data)
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar os usuários!', 'error')
      }
    },

    outroDoc() {
      if (this.descricao === 'Bilhete') {
        this.editedItem.idPEssoa = ''
        this.descricao = 'Outro Doc.'
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        this.ruleBI = [ value => value.length >= 16 && value.length <= 30 || 'Mínimo de 16 caracteres exigido']
      } else {
        this.editedItem.idPEssoa = ''
        this.descricao = 'Bilhete'
        this.mascara = '#########-AA-###'
        ruleBI: [ value => value.length === 16 || 'Mínimo de 16 caracteres exigido']
      }
    },

    close() {
      this.$router.push('/funcionario/menu')
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true
        try {
          var params = {
            idFuncionario: this.editedItem.idFuncionario,
            nome: this.editedItem.nome,
            idPEssoa: this.editedItem.idPEssoa,
            email: this.editedItem.email,
            telefone: this.editedItem.telefone,
            instituicao_descricao: ls.get('instituicaodescricao')
          }

          // Verificando se o funcionário já existe
          let funcionariojaexiste = this.funcionario_verificacao.filter((f) => f.idPessoa === this.editedItem.idPEssoa || f.email === this.editedItem.email || f.bilhete === this.editedItem.idPEssoa);
  
          if (!funcionariojaexiste.length) {
            try {
              let msg = await axios.post('/funcionarioInsertOrUpdate', params).then(res => res.data);
  
              // verificação da mensagem
              if (msg.length) {
                Swal.fire('Erro', 'Erro durante o cadastro do funcionário!', 'error')
              } else {
                Swal.fire('Sucesso', 'Funcionário cadastrado com sucesso!', 'success');
                this.$router.push('/funcionario/listagem');
              }
            } catch (error) {
              Swal.fire('Erro', 'Erro durante o cadastro do funcionário!', 'error')
            }
          } else {
            Swal.fire('Informação', '<p>Número de documento ou email já cadastrado!</p>', 'warning')
          }
        } catch (error) {
          Swal.fire('Erro', 'Erro durante o cadastro do funcionário!', 'error')
        } finally {
          this.isLoading = false;
        }
      }
    }
  }
}
</script>

<style scoped>
.big-container {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  padding: 20px;
}

.form-card {
  width: 100%;
  max-width: 800px;
  border-radius: 12px;
  overflow: hidden;
}

.headline {
  padding: 20px;
  font-weight: 600;
}

@media (max-width: 600px) {
  .big-container {
    padding: 10px;
    align-items: flex-start;
  }
  
  .form-card {
    margin-top: 20px;
  }
}
</style>